/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface UpdateActivityResponseDto
 */
export interface UpdateActivityResponseDto {
    /**
     * Activity ID
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'deletedAt': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'source': UpdateActivityResponseDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof UpdateActivityResponseDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof UpdateActivityResponseDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'type': UpdateActivityResponseDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'activityDate': string;
    /**
     * User ID who performed the activity
     * @type {string}
     * @memberof UpdateActivityResponseDto
     */
    'userId': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof UpdateActivityResponseDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Array of participation IDs that this activity was submitted to
     * @type {Array<string>}
     * @memberof UpdateActivityResponseDto
     */
    'participationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was approved for
     * @type {Array<string>}
     * @memberof UpdateActivityResponseDto
     */
    'approvedParticipationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was declined for
     * @type {Array<string>}
     * @memberof UpdateActivityResponseDto
     */
    'declinedParticipationRecords': Array<string>;
    /**
     * User who performed the activity
     * @type {UserDto}
     * @memberof UpdateActivityResponseDto
     */
    'user': UserDto;
}

export const UpdateActivityResponseDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type UpdateActivityResponseDtoSourceEnum = typeof UpdateActivityResponseDtoSourceEnum[keyof typeof UpdateActivityResponseDtoSourceEnum];
export const UpdateActivityResponseDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type UpdateActivityResponseDtoTypeEnum = typeof UpdateActivityResponseDtoTypeEnum[keyof typeof UpdateActivityResponseDtoTypeEnum];


